'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
import { appendLPSourceToUrl } from '~/components/Link/src/LinkWithSource';
import { ListingCard } from '~/components/ListingCard';
import { Markdown } from '~/components/Markdown';
import type { DestinationRecordFragment } from '~/libs/dato/fragments/destinationFragment';
import { trackBlueprintClicked } from '~/utils';
import { getDestinationUrl, getUrl, isExternalPage, type UrlProps } from '~/utils/datoHelpers';
import styles from './TripCard.module.css';
import type { StaticCardProps } from './TripCard.types';
const StaticCard = t0 => {
  const $ = _c(27);
  const {
    trip
  } = t0;
  const pathname = usePathname() || "";
  const {
    description,
    photo: image,
    title,
    url
  } = trip;
  const t1 = url as UrlProps;
  let t2;
  if ($[0] !== t1) {
    t2 = isExternalPage(t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const isExternal = t2;
  let cardUrlWithSource;
  let t3;
  if ($[2] !== pathname || $[3] !== url) {
    let t4;
    bb0: {
      if (url?._modelApiKey === "destination") {
        const {
          destination
        } = url as DestinationRecordFragment;
        const slug = (url as UrlProps).slug;
        if (!slug) {
          t4 = null;
          break bb0;
        }
        t4 = getDestinationUrl({
          destination: destination ?? undefined,
          slug
        });
        break bb0;
      }
      t4 = getUrl(url as UrlProps);
    }
    const cardUrl = t4;
    cardUrlWithSource = cardUrl ? appendLPSourceToUrl(pathname, cardUrl) : null;
    t3 = cardUrl?.split("/journey-template/")[1]?.split("?")[0];
    $[2] = pathname;
    $[3] = url;
    $[4] = cardUrlWithSource;
    $[5] = t3;
  } else {
    cardUrlWithSource = $[4];
    t3 = $[5];
  }
  const blueprintId = t3;
  let t4;
  if ($[6] !== blueprintId || $[7] !== cardUrlWithSource || $[8] !== title) {
    t4 = blueprintId ? () => trackBlueprintClicked({
      blueprintId,
      title,
      url: cardUrlWithSource ?? undefined
    }) : undefined;
    $[6] = blueprintId;
    $[7] = cardUrlWithSource;
    $[8] = title;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleClick = t4;
  let t5;
  if ($[10] !== image) {
    t5 = <div className={styles.gallerySlot}><ListingCard.Gallery images={image?.responsiveImage ? [{
        data: image.responsiveImage
      }] : []} /></div>;
    $[10] = image;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== cardUrlWithSource || $[13] !== handleClick || $[14] !== isExternal || $[15] !== title) {
    t6 = cardUrlWithSource ? <ListingCard.Link href={cardUrlWithSource} isExternal={isExternal} onClick={handleClick}>{title}</ListingCard.Link> : title;
    $[12] = cardUrlWithSource;
    $[13] = handleClick;
    $[14] = isExternal;
    $[15] = title;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t6) {
    t7 = <ListingCard.Title as="h3">{t6}</ListingCard.Title>;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== description) {
    t8 = description && <Markdown className={styles.markdown}>{description}</Markdown>;
    $[19] = description;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t7 || $[22] !== t8) {
    t9 = <ListingCard.Content><div className={styles.tripCardContentInner}>{t7}{t8}</div></ListingCard.Content>;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t5 || $[25] !== t9) {
    t10 = <ListingCard variant="trip">{t5}{t9}</ListingCard>;
    $[24] = t5;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
};
export { StaticCard };